export const fontSize = {
    display1: 34,
    headline: 24,
    title: 20,
    subheader: 16,
    body: 14,
    caption: 12
};
export const fontWeight = {
    thin: 100,
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
    black: 900
};
export const textTruncate = {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};
export const lineClamp = (count = 2, lineHeight = 1.2, fontSize = 0.875, unit = 'rem', typography) => ({
    ...typography,
    position: 'relative',
    height: `${lineHeight * count * fontSize}${unit}`, // line-height * line-count * fontSize
    overflow: 'hidden',
    lineHeight: lineHeight,
    '&:after': {
        content: '""',
        textAlign: 'right',
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: '50%',
        height: `${lineHeight * fontSize}${unit}`,
        background: 'linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 80%)'
    },
    /* Now add in code for the browsers that support -webkit-line-clamp and overwrite the non-supportive stuff */
    [`@supports (-webkit-line-clamp: ${count})`]: {
        '&': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            '&:after': {
                display: 'none'
            }
        }
    }
});
export default {
    fontSize,
    fontWeight,
    textTruncate
};
//# sourceMappingURL=typography.js.map